var _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgThermometer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.041631 0 0 .041631 2.0556 1.1508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m341.33 288.59v-203.26c0-47.128-38.205-85.333-85.333-85.333s-85.333 38.205-85.333 85.333v203.26c-26.187 23.438-42.667 57.499-42.667 95.408 0 70.693 57.308 128 128 128s128-57.307 128-128c0-37.909-16.48-71.97-42.667-95.407zm-85.333 180.74c-47.128 0-85.333-38.205-85.333-85.333 0-24.637 10.441-47.492 28.455-63.615l14.212-12.72v-222.33c0-23.564 19.103-42.667 42.667-42.667s42.667 19.102 42.667 42.667v222.33l14.212 12.72c18.014 16.123 28.455 38.977 28.455 63.615-2e-3 47.128-38.207 85.333-85.335 85.333z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.041631 0 0 .041631 2.0556 1.1508)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.67,
    y: 170.67,
    width: 42.667,
    height: 256
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.041631 0 0 .041631 2.0556 1.1508)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 384,
    r: 64
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThermometer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thermometer.ed3fdbc9.svg";
export { ForwardRef as ReactComponent };